import { environment } from "../../environment";
import { getApiEndpoint } from "../../utils/constants/api";
import { PAGE_TEMPLATES } from "../../utils/constants/templates";
import { wfetch } from "../../utils/fetch";

export const FETCH_DYNAMIC_PAGES = "FETCH_DYNAMIC_PAGES";

export const fetchDynamicPages = () => {
    return async (dispatch) => {
        const response = await wfetch(
            getApiEndpoint("PAGES", {
                pathParams: { path: "" },
                queryParams: {
                    "@ancestor": environment.APP_BASE,
                    "mgnl:template": `${PAGE_TEMPLATES.PRODUCT_OVERVIEW}|${PAGE_TEMPLATES.PRODUCT_DETAIL}`,
                },
            }),
        );

        if (!response || response.data.results.length === 0) return;

        const payload = {};

        for (const page of response.data.results) {
            payload[page["mgnl:template"]] = page["@path"];
        }

        dispatch({
            type: FETCH_DYNAMIC_PAGES,
            payload,
        });
    };
};
